import { getOrCreateDeviceUUID } from '@/utils/uuid'

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || '';

/**
 * Сохраняет данные сессии пользователя в Redis
 * @param {Object} sessionData - Данные сессии
 * @param {string} sessionData.typePet - Тип питомца ("Кошка" или "Собака")
 * @param {string} [sessionData.typeClient] - Тип клиента ("будущий владелец" или undefined)
 * @param {string} [sessionData.initialVariant] - Начальный вариант
 * @returns {Promise<Object>} Результат сохранения
 */
export async function saveSession(sessionData) {
  const deviceUuid = getOrCreateDeviceUUID();
  
  const response = await fetch(`${API_BASE_URL}/api/session/save`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      device_uuid: deviceUuid,
      type_pet: sessionData.typePet,
      type_client: sessionData.typeClient,
      initial_variant: sessionData.initialVariant || 'standard'
    })
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const result = await response.json();
  
  return result;
}

/**
 * Загружает данные сессии пользователя из Redis
 * @returns {Promise<Object|null>} Данные сессии или null если не найдены
 */
export async function loadSession() {
  const deviceUuid = getOrCreateDeviceUUID();
  
  try {
    
    const response = await fetch(`${API_BASE_URL}/api/session/${deviceUuid}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    
    if (result.success && result.data) {
      return {
        typePet: result.data.type_pet,
        typeClient: result.data.type_client,
        initialVariant: result.data.initial_variant || 'standard'
      };
    } else {
      return null;
    }
  } catch (error) {
    // Не бросаем ошибку, просто возвращаем null
    return null;
  }
}

/**
 * Очищает данные сессии пользователя из Redis
 * @returns {Promise<boolean>} Успешность операции
 */
export async function clearSession() {
  const deviceUuid = getOrCreateDeviceUUID();
  
  try {
    // Используем новый DELETE эндпоинт для полной очистки всех данных пользователя
    const response = await fetch(`${API_BASE_URL}/api/session/clear/${deviceUuid}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    
    return result.success || false;
  } catch (error) {
    return false;
  }
}

/**
 * Отладочная функция для проверки данных в Redis
 * Можно вызвать из консоли браузера: window.checkRedisSession()
 */
export async function debugLoadSession() {
  const sessionData = await loadSession();
  return sessionData;
}

// Добавляем функцию в window для отладки
if (typeof window !== 'undefined') {
  window.checkRedisSession = debugLoadSession;
} 